import type { FC } from 'react';
import Products from './inventory/product/products';
import Warehouses from './inventory/warehouse/warehouses';
import StockLevels from './inventory/stock-level/stockLevels';
import StockAdjustments from './inventory/stock-adjustment/stockAdjustments';
import Categories from './inventory/category/categories';
import Customers from './inventory/customer/customers';
import Factories from './inventory/factory/factories';
import Brands from './inventory/brand/brands';
import Suppliers from './inventory/supplier/suppliers';
import Orders from './inventory/order/orders';
import Sales from './inventory/sale/sales';
import Invoices from './inventory/invoices/invoices';
import Payments from './inventory/payment/payments';
import Report from './dashboard/report/report';
import SalesDashboard from './dashboard/sales/sales';

/**
 * Screen-key -> component map for THIS PRODUCT's pages.
 *
 * The platform's registry (../registry.tsx) spreads this in, so a new project
 * empties this one file and deletes the folders beside it rather than picking
 * domain lines out of a map that also lists the platform's screens.
 *
 * Keys must match the `screen` values in config/domain-config.tsx. A route
 * naming a key that is not here falls back to the Placeholder component, so a
 * mismatch degrades to a visible stub rather than a crash.
 */
export const domainScreenRegistry: Record<string, FC> = {
  products: Products,
  warehouses: Warehouses,
  'stock-levels': StockLevels,
  'stock-adjustments': StockAdjustments,
  categories: Categories,
  customers: Customers,
  factories: Factories,
  brands: Brands,
  suppliers: Suppliers,
  orders: Orders,
  sales: Sales,
  invoices: Invoices,
  payments: Payments,
  report: Report,
  'sales-report': SalesDashboard,
};
